<template>
  <span>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon @click="sheet = !sheet" v-on="on" color="primary">menu</v-icon>
      </template>
      <span>{{ title }}</span>
    </v-tooltip>

    <v-bottom-sheet v-model="sheet">
      <v-sheet>
        <v-list>
          <v-subheader>{{ title }}</v-subheader>
          <i4proActions :page="page" :mode="mode" :origin="page" :actionMaster="true" :itemsMaster="actions" :drawer="true" />
        </v-list>
      </v-sheet>
    </v-bottom-sheet>
  </span>
</template>

<script>
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  props: {
    title: { type: String, default: 'Opções' },
    mode: { type: String, required: true },
    page: { type: String, required: true },
    actions: { type: Array, default: () => [] }
  },
  components: {
    i4proActions: () => import('@/components/partials/i4pro-actions')
  },
  data: () => ({
    sheet: false
  })
};
</script>
